<!-- @format -->

<member-tag>
  <div class="contents contents-wide">
    <section class="contents_area">
      <div class="container_heading">
        <h1 class="heading-01 heading_application">メンバー管理</h1>
        <ul class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="/croco-desk/" class="home">ホーム</a>
          </li>
          <li class="breadcrumb-item">メンバー管理</li>
        </ul>
      </div>
      <!--/.container_heading-->

      <div class="contents_block table">
        <table class="contents_table membership">
          <tbody>
            <tr class="column_membership-crocodesk">
              <th class="name">名前</th>
              <th class="role">権限</th>
              <th class="registration-date">登録日</th>
              <th class="amount">使用金額</th>
              <th class="limit">金額制限</th>
              <th class="edit"></th>
            </tr>

            <tr
              class="row_membership-crocodesk"
              each="{ (member, index) in state.members}"
            >
              <td class="name">
                <div class="user-account_name">
                  <div class="user-account_name-icon">
                    <img
                      if="{ member.user_info.icon_path }"
                      src="{ member.user_info.icon_path }"
                      alt=""
                    />
                    <img
                      if="{ !member.user_info.icon_path }"
                      src="/assets/img/icon_default.svg"
                      alt=""
                    />
                  </div>
                  <p class="user">{ member.name }</p>
                </div>
                <p class="user-account_mail">{ member.mail }</p>
              </td>
              <td class="role">{ Role.get(member.role_id).name }</td>
              <td class="registration-date">{ member.regist_time }</td>
              <td class="amount">
                <div
                  class="row_amount"
                  each="{ budget in member.budget_histories }"
                >
                  <span class="month">{ budget.pay_ym }</span>
                  <span class="amount_money">{ budget.price }円</span>
                </div>
              </td>
              <td class="limit">
                <div if={member.budget === null}>無制限</div>
                <div if={member.budget === 0}>決済できない</div>
                <div if={member.budget > 0}>制限あり</div>
                <div if={member.budget === null || member.budget === 0}>-</div>
                <div if={member.budget > 0}>{Number(member.budget).toLocaleString()}円 / 月</div>
              </td>
              <td class="edit">
                <div class="container_button-edit">
                  <button
                    class="button button-secondary-mini js-modal-open"
                    type="button"
                    value="編集"
                    onclick="{ e => update({ editModalIsOpen: true, modalMember: member }) }"
                  >
                    編集
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <!--/.contents_table-->
      </div>
      <!--/.contents_block-->
    </section>
    <!--/.contents_area-->
  </div>
  <!--/.contents-->

  <member-edit-modal
    is-open="{ state.editModalIsOpen }"
    on-update-member="{ onUpdateMember }"
    on-close="{ e => update({editModalIsOpen: false}) }"
    member="{ state.modalMember }"
  ></member-edit-modal>

  <template if="{false}">
    <h2 class="ui header">
      <i class="icon users"></i>
      メンバー管理
    </h2>

    <div class="ui right aligned basic segment">
      <div class="ui breadcrumb">
        <a href="/menu" class="section">
          <i class="icon home"></i>
          ホーム
        </a>
        <div class="divider">/</div>
        <div class="active section">メンバー管理</div>
      </div>
    </div>

    <div class="ui basic segment">
      <table class="ui very compact table">
        <thead>
          <tr>
            <th>名前</th>
            <th>権限</th>
            <th>登録日</th>
            <th>使用金額</th>
            <th>金額制限</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr each="{ user in state.members}">
            <td class="collapsing">
              <img
                class="ui avatar image"
                src="/{user.user_info.icon_path}"
                if="{user.user_info.icon_path}"
              />
              {user.name}
              <div style="color: grey; font-size: small">{user.mail}</div>
            </td>
            <td class="collapsing">
              <template if="{role = state.Role.get(user.role_id)}">
                {role.name}
              </template>
            </td>
            <td class="collapsing">-</td>

            <td class="collapsing">
              <div each="{item in user.budget_histories}">
                <span style="font-weight: bold">{item.pay_ym}</span>
                &nbsp;
                <span>{Number(item.price).toLocaleString()}円</span>
              </div>
            </td>
            <td class="collapsing">
              <div if="{!user.budget}">無制限</div>
              <div if="{user.budget}">制限あり</div>

              <div if="{!user.budget}">-</div>
              <div if="{user.budget}>{Number(user.budget).toLocaleString()}">
                円 / 月
              </div>
            </td>
            <td class="right aligned collapsing">
              <button
                class="ui mini positive button"
                onclick="{(e)=>CrocoDeskApi.event('member', 'edit', user)}"
              >
                編集
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <member-edit-modal
      modalId="member-edit-modal"
      CrocoDeskApi="{CrocoDeskApi}"
      fetchMember="{fetchMember}"
    ></member-edit-modal>
  </template>

  <script>
    import di from "dependeny-injection";
    import modal from "@tags/modal/croco-desk/member-edit-modal.riot";
    import Role from "@model/role.js";

    export default {
      components: {
        "member-edit-modal": modal,
      },
      CrocoDeskApi: false,
      state: {
        members: [],
        isLoading: true,
        editModalIsOpen: false,
      },
      onMembersUpdate(data) {
        this.update({ members: data });
      },
      fetchMember() {
        this.CrocoDeskApi.request("member", "fetch").then((data) =>
          this.onMembersUpdate(data)
        );
      },
      onBeforeMount() {
        this.Role = Role;
        this.CrocoDeskApi = di.createApi();
        this.fetchMember();
      },
      onUpdateMember(param) {
        this.CrocoDeskApi.request("member", "update", param).then((data) => {
          this.fetchMember();
          this.update({ editModalIsOpen: false });
        });
      },
    };
  </script>
</member-tag>
